import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — resets window scroll position to (0, 0) on every route change.
 *
 * React Router's default behavior preserves scroll position across navigations,
 * which causes a jarring UX when the user scrolls to a footer link and clicks
 * it: they land at the bottom of the next page instead of the top.
 *
 * If the URL includes a hash (e.g., "/terms#section-3"), we defer to the
 * browser's native anchor-jump behavior instead of forcing top.
 *
 * Rendered inside <Router> but outside individual routes so it fires on every
 * navigation regardless of which page is mounted.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL has a #hash, let the browser handle anchor scrolling.
    if (hash) return;

    // "instant" avoids animating during transitions; snappier feel than "smooth"
    // when jumping between long pages.
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [pathname, hash]);

  return null;
}
